import { urlApiAuth } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBodyLogin, IResponseLogin } from '~/utils/interface/auth';
import { IBaseResponse } from '~/utils/interface/base';

const authApi = {
  login(payload: { body: IBodyLogin }) {
    const { body } = payload;
    const url = `${urlApiAuth.login}`;
    return axiosClient.post<IBaseResponse<IResponseLogin>>(url, body);
  },
};

export default authApi;
